import { BasicMentee } from 'redux/schemas/models/course';
import { MentoringProgram } from 'redux/schemas/models/mentoring-programs';

export enum OfferingTypes {
  COURSE = 'course',
  JOURNEY = 'journey',
  MENTORSHIP_PROGRAM = 'mentorship_program',
}

// Union type for BasicMentee (course mentee info) and MentoringProgram (mentorship program mentee info)
export type MenteeInfo =
  | (BasicMentee & { type: OfferingTypes.COURSE | OfferingTypes.JOURNEY })
  | (MentoringProgram & { type: OfferingTypes.MENTORSHIP_PROGRAM, catalogId?: string });
// catalogId is included for compatibility with course-based logic
